// extracted by mini-css-extract-plugin
export default {"header":"styles_header__qrumX","sup":"styles_sup__bbD4D","logo":"styles_logo__0cgSe"};